import { Injectable } from "@angular/core";
import { HttpService } from "src/app/shared/services/http.service";
import { METRIC, Metric } from "@backend/common/analytics/metrics";
import { NavigationEnd, Router } from "@angular/router";
import { filter, pairwise, startWith, tap } from "rxjs";
import { JWTService } from "./jwt.service";
import { environment } from "src/environments/environment";

export { METRIC } from "@backend/common/analytics/metrics";

const routesWhitelist = ["/login", "/my-dental/medical-history", "/r/", "/my-dental/nhs-pr", "/my-dental/account", "/restricted"];

// Routes that contain user-specific identifiers or magic links
const userSpecificRoutes = ["/login/verify-pass"];

@Injectable({
  providedIn: "root",
})
export class AnalyticsService {
  constructor(private _httpService: HttpService, private _router: Router, private _jwtService: JWTService) {
    this._router.events
      .pipe(
        filter(
          (event: NavigationEnd) =>
            this._isRouteTrackingEnabled &&
            event instanceof NavigationEnd &&
            routesWhitelist.some((route) => event.url.includes(route)) &&
            !event.urlAfterRedirects.includes("canary")
        ),
        startWith(null), // Start with null to get the first NavigationEnd event
        pairwise(), // Get previous and current NavigationEnd events together
        tap(([previous, current]) => {
          const { type } = this._jwtService.referrerAsJson;
          this.track(new METRIC.PatientRouting(type, this._normalizeUrl(previous?.url || ""), this._normalizeUrl(current?.url || "")));
        })
      )
      .subscribe();
  }

  private _normalizeUrl(url: string): string {
    const matchingRoute = userSpecificRoutes.find((route) => url.includes(route));
    if (matchingRoute) {
      return matchingRoute;
    }
    return url;
  }

  private get _isRouteTrackingEnabled(): boolean {
    return environment.ANALYTICS_MIXPANEL_ROUTE_TRACKING;
  }

  public track(metric: Metric): void {
    const { metricName, properties } = metric;
    // Given this a generic name as using e.g. 'analytics' or 'track'
    // can cause the request to be blocked by some browsers (e.g. arc).
    this._httpService.post("/v2/patient", { metricName, properties }).subscribe();
  }
}
